import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import '@/app/styles/global.css'
import '@/shared/config/i18n'

if (
  __ENABLE_MOCKS__ &&
  !window.__DISABLE_MOCK_WORKER__ &&
  typeof navigator.serviceWorker?.register === 'function'
) {
  const { mockWorker } = await import('@/app/mocks/browser')
  await mockWorker.start({ onUnhandledRequest: 'error' })
}

const root = document.getElementById('root')
if (!root) {
  throw new Error('Application root element is missing')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
